import { KycStates } from '@ha/api/v2/types/Kyc';
import { ListItemText, theme } from '@ha/dsl';
import { makeStyles } from 'tss-react/mui';
import { MenuItem } from 'ha/components/Menu/MenuItem';
import { SmartTrack as Track } from 'ha/components/track/SmartTrack';
import { useIntl } from 'ha/i18n';
import React from 'react';

import { KycStatusBadge } from './KycStatusBadge';

const useStyles = makeStyles()({
  verificationItemLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
});

interface Props {
  kycStatus: KycStates | undefined;
}

export function NavBarPayoutListItems({ kycStatus }: Props) {
  const { classes } = useStyles();

  const { T, urlResolver } = useIntl();

  return (
    <div>
      <Track name="Clicked Payout methods in navigation">
        <MenuItem to={urlResolver.getPayoutMethodsUrl()}>
          <ListItemText primary={T('payout_methods.page_title')} />
        </MenuItem>
      </Track>

      <Track name="Clicked Billing details in navigation">
        <MenuItem to={urlResolver.getBillingUrl()}>
          <ListItemText primary={T('billing_details.page_title')} />
        </MenuItem>
      </Track>

      <Track name="Clicked Transactional history in navigation">
        <MenuItem to={urlResolver.getTransactionHistoryUrl()}>
          <ListItemText primary={T('transaction_history.page_title')} />
        </MenuItem>
      </Track>

      <Track name="Clicked Payment requests in navigation">
        <MenuItem to={urlResolver.getPayoutsPaymentRequests()}>
          <ListItemText primary={T('payment_requests.page_title')} />
        </MenuItem>
      </Track>

      <Track name="Clicked Invoices in navigation">
        <MenuItem to={urlResolver.getInvoicesUrl()}>
          <ListItemText primary={T('invoices.page_title')} />
        </MenuItem>
      </Track>

      <Track name="Clicked Comission plan in navigation">
        <MenuItem to={urlResolver.getCommissionPlanUrl()}>
          <ListItemText primary={T('commission_plan.page_title')} />
        </MenuItem>
      </Track>

      <Track name="Clicked Verify identity in navigation">
        <MenuItem to={urlResolver.getVerifyIdentityUrl()}>
          <ListItemText
            primary={
              <div className={classes.verificationItemLabel}>
                {T('verify_identity.page_title')}

                {kycStatus && <KycStatusBadge kycStatus={kycStatus} />}
              </div>
            }
          />
        </MenuItem>
      </Track>
    </div>
  );
}
